/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';
import {Row} from 'react-bootstrap';
import {useSortedData} from "../../../Hooks/ListHooks";
import {AddItemButton as defaultAddItemButton} from "./Buttons/AddItemButton";
import {EditItemButton as defaultEditItemButton} from "./Buttons/EditItemButton";
import {RemoveItemButton as defaultRemoveItemButton} from "./Buttons/RemoveItemButton";
import {MutableListRow} from "./MutableListRow";
import {StreamBankListEmptyRow} from "../RecordRenderers/StreamBankListEmptyRow";

export const MutableList = (props) => {
    
    const {
        Data,
        sortKey,
        DataTypeName,
        PrimaryKeyName,
        GetTitle,
        GetSubTitle,
        Type,
        UpdateItem, // function to update an item, called by MutableListRow's ItemComponent
        AdditionalTypeProps,
        Editable,
        RemoveItem,
        RemoveItemRow = null,
        RemoveItemButton = defaultRemoveItemButton,
        showRemoveButton = (item) => true,
        
        AddItem,
        AddItemButton = defaultAddItemButton,
        showAddButton = (item) => !!AddItem,
        
        onEditItem,
        EditItemButton = defaultEditItemButton,
        showEditButton = (item) => false,
        isItemEditable = (item) => true,
        children,
        
        EmptyItemComponent=StreamBankListEmptyRow,
        
        className="sb-mutable-list-item-section",
        rowClassName="pop-row",
        itemClassName="pop-col",
        extraClassName = '',
        
    } = props;
    
    const data = useSortedData(Data, sortKey);
    
    return (
        <div className={[className, extraClassName].join(' ')}>
            {children}
            {data && data.map(
                (x, n) => {
                    const itemKey = x[PrimaryKeyName] || x._tempId || n;
                    return (
                        <MutableListRow
                            isEditable={Editable}
                            rowClassName={rowClassName}
                            
                            /* props for ItemComponent  */
                            key={itemKey}
                            item={x}
                            itemClassName={itemClassName}
                            ItemComponent={Type}
                            isItemEditable={isItemEditable}
                            updateItem={UpdateItem}
                            additionalItemComponentProps={AdditionalTypeProps}
                            title={GetTitle?.(x)}
                            subtitle={GetSubTitle?.(x)}
                            
                            EditItemButton={EditItemButton}
                            showEditButton={showEditButton(x)}
                            onEditItem={() => onEditItem(x)}
                            
                            RemoveItemRow={RemoveItemRow}
                            RemoveItemButton={RemoveItemButton}
                            showRemoveButton={showRemoveButton(x)}
                            onRemoveItem={() => RemoveItem(x)}
                        />
                    );
                }
            )}
            {Editable && AddItemButton && (
                <Row className={[rowClassName, 'sb-mutable-list-add-row'].filter(Boolean).join(' ')}>
                    <AddItemButton
                        show={showAddButton()}
                        onAdd={AddItem}
                        dataTypeName={DataTypeName}
                    />
                </Row>
            )}
            {
                (!data?.length) && (!Editable && AddItemButton) && EmptyItemComponent ? (
                    <Row className={rowClassName}>
                        <EmptyItemComponent
                            fieldDef={AdditionalTypeProps?.FieldDef}
                        />
                    </Row>
                ) : null
            }
        </div>
    );
};
